<ng-container *ngIf="matFormField._control && matFormField._control.ngControl">
  {{ matFormField._control.ngControl.errors | errorDisplay }}
</ng-container>
